/**
 * @file Restrictions.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React, { useState } from 'react'
import Widget from '../Widget'
import DgSwitch from '../../../../components/forms/DgSwitch'

function Restrictions({ width }) {

    const [assetData, setAssetData] = useState([
        { name: "Fund 1", slug: "Fund-1", value: 15, switch: true, status: "active" },
        { name: "Fund 2", slug: "Fund-2", value: 0, switch: false, status: "inactive" }
    ])

    const handleSwitch = (asset, switchState) => {
        setTimeout(() => {
            setAssetData(prevAssetData => {
                return prevAssetData.map(item => {
                    if (item.slug === asset) {
                        return {
                            ...item,
                            switch: switchState ? false : true
                        };
                    }
                    return item;
                });
            });
        }, 200);
    }

    return (
        <Widget name={"restrictions"} width={width}>
            <div className="heading">
                <h1 className="title">Restrictions</h1>
            </div>
            <p className="description">
                Avoided Assets
            </p>
            <table>
                <tbody>
                    {assetData.map((asset, index) => (
                        <tr key={asset.slug} className={asset.status}>
                            <td className='asset-logo'>
                                <img src="/assets/dell-logo.svg" alt="" />
                            </td>
                            <td className='asset-name'>{asset.name}</td>
                            <td className='switch'><DgSwitch checked={asset.switch} action={() => handleSwitch(asset.slug, asset.switch)} /></td>
                        </tr>
                    ))}

                </tbody>
            </table>
            <div className="view-assets link">
                <a no-href={true}>View all restrictions</a>
            </div>
        </Widget >
    )
}

export default Restrictions